import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "Title mt-0 mb-0" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "mt-8 mb-10 lg:mb-[52px]" }

import { ref, computed } from 'vue';
import VariationsField from '../shared/Fields/VariationsField.vue';
import { schema } from './schema';
import { initialValues } from './initialValues';
import ImportantInformationField from '../shared/Fields/ImportantInformationField.vue';
import UploadedFileField from '../shared/Fields/UploadedFileField.vue';
import PatientData from '../shared/PatientData.vue';
import ProductForm from '../shared/ProductForm.vue';
import CalendarSection from '../ui/CalendarComponent/CalendarSection.vue';
import Terms from '../shared/Terms.vue';
import { useField } from 'vee-validate';


export default {
  __name: 'KonsultacjaPsychiatryczna',
  props: {
    checkoutlink: { type: String, required: true },
    price: {
        type: String,
        required: true,
    },
    id: {
        type: Number,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    shortdescription: {
        type: String,
        required: true,
    },
    customer: {
        type: String,
        required: false,
    },
    variations: {
        type: String,
        required: false,
    },
    variantname: {
        type: String,
        required: false,
    },
},
  setup(__props) {

const props = __props;



const customerData = JSON.parse(props.customer || '{}');

const variationsData = JSON.parse(props.variations || []);
const selectedVariation = ref(variationsData[0]?.variation_id);

const selectVariation = (variationId) => {
    selectedVariation.value = variationId;
};

const values = computed(() => initialValues(customerData));

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(ProductForm, {
    schema: _unref(schema),
    initialValues: _unref(values),
    id: __props.id,
    checkoutlink: __props.checkoutlink,
    price: __props.price,
    title: __props.title,
    variations: _unref(variationsData),
    selectedVariation: selectedVariation.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", {
        class: "Text mt-3 md:max-w-[383px]",
        innerHTML: __props.shortdescription
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CalendarSection, { productId: __props.id }, null, 8, ["productId"]),
        _createVNode(ImportantInformationField, { placeholder: "Wpisz swoje dolegliwości , aby Iekarz mógł przygotować się do rozmowy" }),
        _createVNode(UploadedFileField)
      ]),
      _createVNode(PatientData),
      _createVNode(VariationsField, {
        name: __props.variantname,
        variations: _unref(variationsData),
        selectedVariation: selectedVariation.value,
        selectVariation: selectVariation
      }, null, 8, ["name", "variations", "selectedVariation"]),
      _createVNode(Terms)
    ]),
    _: 1
  }, 8, ["schema", "initialValues", "id", "checkoutlink", "price", "title", "variations", "selectedVariation"]))
}
}

}